import { Component, ViewContainerRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DialogService } from '../../_services/dialog.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { PosStation, Printer, Reader } from '../../_models/fundraising/PosStation';
import { StationService } from '../../_services/fundraising/station.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceInfoModalComponent } from './device-info-modal.component';

@Component({
  selector: 'app-station-management',
  templateUrl: './station-management.component.html',
  styleUrls: ['../../_shared/base.management.component.css']
})

export class StationManagementComponent implements OnInit {
  public loading = true;

  public display: PosStation[];
  public items: PosStation[];

  public searchText: string;

  private bsModalRef: any;

  constructor(
    private router: Router,
    private stationService: StationService,
    private dialogService: DialogService,
    private viewRef: ViewContainerRef,
    private spinner: NgxSpinnerService,
    private modalService: BsModalService) {

  }

  ngOnInit() {
    this.load();
  }

  private filterName(name:string, searchQuery:string): boolean{
    return name.toLowerCase().includes(searchQuery.toLowerCase())
  }

  public search() {
    this.display = this.items.filter(station => this.filterName(station.name, this.searchText))
  }

  public delete(id: number) {
    this.dialogService.confirm('Confirm Delete', 'Are you sure you want to unassign this station?', this.viewRef).then(result => {
      if (result) {
        this.loading = true;
        this.spinner.show();

        this.stationService.delete(id)
          .subscribe(
            () => {
              this.spinner.hide();
              this.load();
          },
            error => {
              this.spinner.hide();
              this.dialogService.error(
                error,
                `Unable to unassign this station`,
                this.viewRef);
          });
      }
    });
  }


  private load() {
    this.spinner.show();

    this.stationService.getAll().subscribe(data => {
      this.display = data;
      this.items = data;

      this.loading = false;
      this.spinner.hide();
    },
    error => {
      this.dialogService.alert(
        'Uh oh something went wrong...',
        `Unable to load stations: ${error.error}`,
        this.viewRef);

        this.loading = false;
        this.spinner.hide();
    });
  }

  public create() {
    this.router.navigate(['/portal/fundraising/cue5050/station/create']);
  }

  public edit(id: number) {
    this.router.navigate([`/portal/fundraising/cue5050/station/update/${id}`]);
  }

  deviceDetails(device: Printer | Reader) {
    const modalConfig = {
      backdrop: true,
      ignoreBackdropClick: true
    };

    const initialState = {
      device: {
        name: device.name,
        type: (device as Printer)?.macAddress ? 'Printer' : 'Reader',
        model: (device as Printer)?.macAddress ? 'Bluetooth Thermal Printer' : (device as Reader)?.type,
        identifier: (device as Printer)?.macAddress || (device as Reader)?.serialNumber,
        dateCreated: device.dateCreated
      }
    };

    this.bsModalRef = this.modalService
      .show(
        DeviceInfoModalComponent,
          Object.assign({}, modalConfig, { class: 'modal-md', initialState })
      );

  }
}
